import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import Header from './Header';

function BaseLayout({
  children,
  mainPanelStyle,
  noHeader = false,
  navItems,
  userNavItems,
  app,
  search,
  success,
  error,
}) {
  const [baseLayoutSidebarClosed, setBaseLayoutSidebarClosed] = useState(false);

  const getAppClassNames = () => {
    const classNames = ['sidebar-layout'];
    if (baseLayoutSidebarClosed) {
      classNames.push('sidebar-is-closed');
    }
    return classNames.join(' ');
  };

  return (
    <div id="app" className={getAppClassNames()}>
      <Sidebar
        navItems={navItems}
        userNavItems={userNavItems}
        baseLayoutSidebarClosed={baseLayoutSidebarClosed}
        setBaseLayoutSidebarClosed={setBaseLayoutSidebarClosed}
      />

      <div className="main-panel" style={mainPanelStyle}>

        {!noHeader && (
          <Header
            app={app}
            search={search}
            success={success}
            error={error}
          />
        )}

        {children}

      </div>
    </div>
  );
}

BaseLayout.propTypes = {
  children: PropTypes.node,
  mainPanelStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  noHeader: PropTypes.bool,
  navItems: PropTypes.node,
  userNavItems: PropTypes.node,
  app: PropTypes.string,
  search: PropTypes.node,
  success: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

BaseLayout.defaultProps = {
  children: null,
  mainPanelStyle: undefined,
  noHeader: false,
  navItems: null,
  userNavItems: null,
  app: undefined,
  search: null,
  success: null,
  error: null,
};

export default BaseLayout;
